// src/components/dialog/DlgIntegrityCheck.tsx

import { Dialog, DialogContent, DialogTitle } from '@mui/material'

import { KARMA_BasicDialog } from '@/types/karma/dialog'

import { IntegrityOC } from '..'

export const DlgIntegrityCheck = ({ onClose, open }: KARMA_BasicDialog) => (
  <Dialog fullWidth={true} maxWidth={'md'} onClose={onClose} open={open}>
    <DialogTitle>Integritätsprüfung</DialogTitle>

    <DialogContent>
      <IntegrityOC />
    </DialogContent>
  </Dialog>
)
